import React from "react";
import { HomePage} from "./pages";

//create our root component
function App() {
  return ( 
  <section className="homepage">
    <HomePage />
  </section>
);
};

export default App;
